module.exports = __webpack_public_path__ + "img/mao_segurando_celular_sem_logo.ed0b1b25.png";